import ViewSummary from "./ViewSummary";
interface ViewSummaryProps {
  // Props remain the same, but the component's internal rendering changes
  pageTypeSummary?: string;
}
const LoanApplicationOverview = () => {
  return (
    <ViewSummary
        pageTypeSummary="loansummary"
    />
  );
};

export default LoanApplicationOverview;